import { TypeSegment } from "@/lib/redux/features/flight/type"

export const groupSegments = (currentSeg: TypeSegment, segments: TypeSegment[]): TypeSegment[] => {
  const group: TypeSegment[] = []
  const visited = new Set<TypeSegment>()
  let segment: TypeSegment | undefined = currentSeg

  while (segment && !visited.has(segment)) {
    group.push(segment)
    visited.add(segment)

    segment = segments.find(
      (candidate) =>
        !visited.has(candidate) &&
        candidate.leg === segment?.leg &&
        candidate.startPoint === segment?.endPoint,
    )
  }

  return group
}